import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ConfirmChallengeRequest
*  Данные для выполнения подтверждения кода
*/
export class ConfirmChallengeRequest extends ActiveModel {

/**
  * challengeId
  * Идентификатор подтверждения<br>
  */
  @ActiveField('')
  challengeId: string = ''


/**
  * code
  * Код подтверждения<br>
  */
  @ActiveField('')
  code: string = ''
}
